const IS_IOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

export {
  IS_IOS,
};